import React, {useEffect, useState} from "react";
import PlotlyPlot from "../../../../common/components/PlotlyPlot";
import {loadProtocolHRHRVData} from "../../services/protocols";
import {PlotParams} from "react-plotly.js";
import {IProtocol} from "../../../types/protocol";
import {ICompany} from "../../../../common/types";
import {Box, Loader} from "@mantine/core";

interface HrHrvChartProps {
    activeCompany: ICompany;
    selectedProtocol: IProtocol | undefined;
    refreshTrigger?: number
}

export const HrHrvChart: React.FC<HrHrvChartProps> = ({activeCompany, selectedProtocol, refreshTrigger}) => {
    const [hrHrvData, setHrHrvData] = useState<PlotParams>()
    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        if (selectedProtocol) {
            setLoading(true)
            loadProtocolHRHRVData(activeCompany.id, selectedProtocol).then((data) => {
                // the data comes with the Plotly figure defined but with the data streamed to us
                // in a data field that we need to extract and insert into the plotly char
                // so transform the data and insert into the chart
                const num_points = data.data.length
                const x = new Array<string>(num_points)
                const hr_y = new Array<number>(num_points)
                const hrv_y = new Array<number>(num_points)

                data.data.forEach(([time, hr, hrv], index) => {
                    x[index] = time
                    hr_y[index] = hr
                    hrv_y[index] = hrv
                })
                setHrHrvData({
                        layout: {
                            ...data.figure.layout,
                        },
                        config: {
                            responsive: true
                        },
                        data:
                            [{
                                ...data.figure.data[0],
                                x: x,
                                y: hr_y,
                                yaxis: "y"
                            },
                                {
                                    ...data.figure.data[1],
                                    x: x,
                                    y: hrv_y,
                                    yaxis: "y2"
                                }
                            ]
                    }
                )
            }).catch(() => {
                // eat the error since notification would already be called
            }).finally(() => {
                setLoading(false)
            })
        }
    }, [selectedProtocol, refreshTrigger])

    const renderLoading = () => {
        return (
            <Box style={{position: "absolute", zIndex: "10", top: "calc(50% - 2em)", left: "calc(50% - 2em)"}}>
                <Loader size="4em" color="var(--bios-strong-accent)"/>
            </Box>
        )
    }

    if (hrHrvData) {
        return (
            <Box>
                <PlotlyPlot {...hrHrvData}/>
                {
                    loading ? renderLoading() : <></>
                }
            </Box>
        )
    } else {
        return (
            <Box>
                {renderLoading()}
            </Box>
        )
    }
}
